import { ResetIdentitySignInRequestSchema, ResetIdentitySignInResponseSchema } from '../../shared/reset-identity-sign-in.schema';
/**
 * Reset Org Member Sign-In Endpoint Contract
 * Same reset as the super-admin one, for a system admin of the person's home
 * organization.
 */ export const resetOrgMemberSignInContract = {
    method: 'POST',
    path: '/api/v2/org-member/:id/reset-sign-in',
    description: "Reset an organization member's sign-in",
    requestSchema: ResetIdentitySignInRequestSchema,
    responseSchema: ResetIdentitySignInResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            400: 'Bad Request - own account, user not active, sign-in disabled, home org SSO-enforced, deleted or unknown',
            401: 'Unauthorized - user not authenticated',
            403: "Forbidden - caller is not a system admin of the person's home organization",
            404: 'User or tenant not found',
            409: 'Conflict - the sign-in identity changed while the reset was running, or an email change has not reached the sign-in account yet',
            503: 'Service Unavailable - identity provider unreachable'
        }
    }
};

//# sourceMappingURL=reset-org-member-sign-in.contract.js.map